import React, { useEffect, useState } from "react";
import CollectiblesCard from "../../../../components/organizer/assets/collectibles-card/collectibles-card";
import { MODULE_API } from "../../../../apis";
import { Button } from "../../../../components/styled-components/button";
import "../../../../components/form/inventory/inventory.style.css";

function NewForm() {
  const [allCollectibles, setAllCollectibles] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchCollectibles();
  }, []);

  const fetchCollectibles = async () => {
    try {
        setIsLoading(true)
      let collectibles = await MODULE_API.fetchAll({
        pageNum: 1,
        limit: 20,
      });

      if (collectibles.status === 200) {
        setIsLoading(false)
        setAllCollectibles(collectibles.body);
      }
    } catch (e) {
        setIsLoading(false)

      console.log(e);
    }
  };

  console.log("collectibles in organizer module", allCollectibles);

  return (
    <>
      {isLoading ? (
        <div class="loader" ng-hide="data.length > 0"></div>
      ) : null}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 15%",
          margin: "4rem 0",
        }}
      >
        <div></div>
        <p
          style={{
            textAlign: "center",
            fontSize: "2.5rem",
            fontWeight: "bold",
            margin: "0",
          }}
        >
          My Collectibles
        </p>
        <Button onClick={fetchCollectibles}>Sync Data</Button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "4rem",
          padding: "0 15%",
          flexWrap: "wrap",
        }}
      >
        {allCollectibles &&
          allCollectibles.map((data, index) => (
            <CollectiblesCard key={index + 1} data={data} />
          ))}
        {/* <CollectiblesCard />
        <CollectiblesCard />
        <CollectiblesCard />
        <CollectiblesCard />
        <CollectiblesCard />
        <CollectiblesCard />
        <CollectiblesCard /> */}
      </div>
    </>
  );
}

export default NewForm;
